
const githubLink = 'https://stackoverflow.com/users/7718559/kousik-mitra'
const stackoverflowLink = 'https://stackoverflow.com/users/7718559/mitter'
const linkedinLink = 'https://www.linkedin.com/in/kousik-m-83235aa0'
const instagramLink = 'https://www.instagram.com/_k.mitter_/'


export { githubLink,
    stackoverflowLink,
    linkedinLink,
    instagramLink };